import clsx from 'clsx'

interface Error500Props {}

export const Error500 = (props: Error500Props): JSX.Element => {
  return (
    <>
      <div className={clsx('text-center', 'mt-40')}>
        <h1 className={clsx('text-9xl', 'font-bold', 'mb-8')}>500</h1>
        <h2 className={clsx('text-3xl', 'font-bold', 'mb-6')}>Server Error</h2>
        <p>
          サーバーとの通信時にエラーが発生しました。
          <br />
          繰り返し発生する場合には管理者にお問い合わせください。
        </p>
      </div>
    </>
  )
}
